import React from 'react';

import { ConfirmationDialog, ConfirmationDialogVariant } from 'src/components';
import { Apollo } from 'src/gql/generated';
import { useDispatchSuccessSnack } from 'src/helpers';

interface RemindRecipientsProps {
  isOpen: boolean;
  onClose: () => void;
  workflowId: UUID;
}

export function RemindRecipientsDialog({ isOpen, onClose, workflowId }: RemindRecipientsProps) {
  const [renotifyCurrentStep] = Apollo.useRenotifyCurrentStepMutation();
  const dispatchRenotifySuccessSnack = useDispatchSuccessSnack({
    message: 'Recipients with incomplete actions successfully reminded.',
  });

  async function renotify() {
    const { data } = await renotifyCurrentStep({ variables: { workflowId } });
    if (data) dispatchRenotifySuccessSnack();
  }

  return (
    <ConfirmationDialog
      message="A reminder is sent to all recipients in the currently-active step.  Click remind to continue."
      open={isOpen}
      primaryText="Remind"
      title="Remind recipients"
      variant={ConfirmationDialogVariant.Info}
      onClickPrimary={renotify}
      onClose={onClose}
    />
  );
}
